/* ============================================================
   CURRENTLY — mobile drawer redesign (accordion concept)
   Rebuilds the hamburger drawer menu (.drawer__main-menu) as a
   cream editorial accordion, using the menu's own links.
   Install: Assets > Add new asset > cr-drawer.js,
   then <script src="{{ 'cr-drawer.js' | asset_url }}" defer></script>
   in layout/theme.liquid before </body>.
   No theme settings or Liquid changes needed.
   ============================================================ */
(function () {
  'use strict';

  /* Clean label text out of a title node (drops chevrons + screen-reader text) */
  function cleanLabel(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .sliderule__chevron--right, .sliderule__chevron--left, svg').forEach(function (n) { n.remove(); });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function build(menu) {
    if (!menu || menu.dataset.crRedesigned) return;
    menu.dataset.crRedesigned = '1';

    var frag = document.createDocumentFragment();
    var wrap = document.createElement('div');
    wrap.className = 'cr-drawer';

    var over = document.createElement('div');
    over.className = 'cr-overline';
    over.textContent = 'Menu \u2014 Index';
    wrap.appendChild(over);

    var wrappers = menu.querySelectorAll(':scope > .sliderule__wrapper');
    var n = 0;
    wrappers.forEach(function (w) {
      /* top-level label: the drill-down open button's title ... */
      var btnTitle = w.querySelector(':scope > button.sliderow .sliderow__title');
      /* ... and its link: first anchor NOT inside the children list.
         (Parents keep theirs in the back-row; plain links nest in .sliderow.) */
      var linkTitle = null;
      var anchors = w.querySelectorAll('a.sliderow__title');
      for (var ai = 0; ai < anchors.length; ai++) {
        if (!anchors[ai].closest('.sliderow__links')) { linkTitle = anchors[ai]; break; }
      }
      var label = cleanLabel(btnTitle) || cleanLabel(linkTitle);
      var href = linkTitle ? linkTitle.getAttribute('href') : '#';
      if (!label) return;

      /* children: every leaf link under this item, flattened, in order */
      var kids = [];
      var seen = {};
      w.querySelectorAll('.sliderow__links a.sliderow__title').forEach(function (a) {
        var t = cleanLabel(a);
        var h = a.getAttribute('href') || '#';
        var key = h + '|' + t;
        if (t && !seen[key]) { seen[key] = 1; kids.push({ label: t, href: h }); }
      });

      var row = document.createElement('div');
      row.className = 'cr-row';

      n += 1;
      var top = document.createElement('div');
      top.className = 'cr-top';

      var num = document.createElement('span');
      num.className = 'cr-num';
      num.textContent = String(n).padStart(2, '0');
      top.appendChild(num);

      var lab = (kids.length ? document.createElement('span') : document.createElement('a'));
      lab.className = 'cr-label';
      if (!kids.length) lab.href = href;
      lab.textContent = label;
      top.appendChild(lab);

      if (kids.length) {
        var kidsBox = document.createElement('div');
        kidsBox.className = 'cr-children';
        kids.forEach(function (k) {
          var a = document.createElement('a');
          a.href = k.href;
          a.textContent = k.label;
          if (/^shop all$/i.test(k.label)) a.classList.add('cr-shopall');
          kidsBox.appendChild(a);
        });

        var toggle = document.createElement('button');
        toggle.className = 'cr-toggle';
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'false');
        top.setAttribute('role', 'button');
        toggle.setAttribute('aria-label', 'Expand ' + label);
        toggle.textContent = '+';
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var open = kidsBox.classList.toggle('cr-open');
          toggle.textContent = open ? '\u2212' : '+';
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          toggle.setAttribute('aria-label', (open ? 'Collapse ' : 'Expand ') + label);
        });
        /* tapping the label row (not the text link) also toggles */
        top.addEventListener('click', function (e) {
          if (e.target.closest('a')) return;
          toggle.click();
        });

        top.appendChild(toggle);
        row.appendChild(top);
        row.appendChild(kidsBox);
      } else {
        row.appendChild(top);
      }

      wrap.appendChild(row);
    });

    /* footer: account links (theme's drawer bottom keeps currency + instagram) */
    var foot = document.createElement('div');
    foot.className = 'cr-foot';
    [['Log in', '/account/login'], ['Create account', '/account/register']].forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[1];
      a.textContent = l[0];
      foot.appendChild(a);
    });
    wrap.appendChild(foot);

    frag.appendChild(wrap);
    menu.appendChild(frag);
    menu.classList.add('cr-redesigned');
  }

  function run() {
    document.querySelectorAll('.drawer__main-menu').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* safety net in case the drawer renders late */
  var mo = new MutationObserver(function () {
    var pending = false;
    document.querySelectorAll('.drawer__main-menu').forEach(function (m) {
      if (!m.dataset.crRedesigned) pending = true;
    });
    if (pending) run(); else mo.disconnect();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
